import { DISPLAY_CURRENCIES } from "common/constants";
import {
  commonActions,
  selectDisplayCurrency,
} from "@shared/slices/common.slice";
import { useDispatch, useSelector } from "react-redux";
import Flex from "common/Boxes/Flex";
import Text from "common/Typography/Text";
import SquareSwitch from "common/Switch/SquareSwitch";
import { BTC } from "common/Icons/Icons";
import React, { CSSProperties } from "react";
import styled from "styled-components";

interface CurrencyToggleProps {
  style?: CSSProperties;
}

const CurrencyToggle = ({ style }: CurrencyToggleProps) => {
  const dispatch = useDispatch();
  const displayCurrency = useSelector(selectDisplayCurrency);

  const onChange = () => {
    const nextCurrency =
      displayCurrency === DISPLAY_CURRENCIES.USD
        ? DISPLAY_CURRENCIES.BTC
        : DISPLAY_CURRENCIES.USD;
    dispatch(commonActions.setDisplayCurrency(nextCurrency));
  };

  return (
    <Flex style={style}>
      <Text>Currency</Text>
      <SquareSwitch
        items={[
          { key: DISPLAY_CURRENCIES.USD, label: <IconWrapper>$</IconWrapper> },
          {
            key: DISPLAY_CURRENCIES.BTC,
            label: (
              <IconWrapper>
                <BTC />
              </IconWrapper>
            ),
          },
        ]}
        selectedKey={displayCurrency}
        onChange={onChange}
      />
    </Flex>
  );
};

export default CurrencyToggle;

const IconWrapper = styled.div`
  width: 16px;
  display: flex;
  justify-content: center;
`;
